define("Ames.ConfigurableItems.COnfigurablePDP", [
  "Ames.ConfigurableItems.COnfigurablePDP.View",
  "Utils",
  "Profile.Model",
  "Cart.AddToCart.Button.View.Extension",
  "Ames.ConfigurableItems.NonInventory.StockMessage",
  // 'Header.MiniCart.View.Extension',
], function (
  COnfigurablePDPView,
  Utils,
  ProfileModel,
  CartAddToCartButtonView,
  NonInventoryStockMessage
  // HeaderMiniCartView,
) {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      // Show the Out of Stock Message for non-inventory items (configurables)
      // on PDP and PLP, same as inventory items / kits
      NonInventoryStockMessage.mountToApp(container);

      // using the 'Layout' component we add a new child view inside the 'Header' existing view
      // // (there will be a DOM element with the HTML attribute data-view="Header.Logo")
      // // more documentation of the Extensibility API in
      // // https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html

      // /** @type {LayoutComponent} */
      var layout = container.getComponent("Layout");

      var pdp = container.getComponent("PDP");

      var userProfile = container.getComponent("UserProfile");

      var cartComponent = container.getComponent("Cart");

      cartComponent.cancelableOn("beforeAddLine", function beforeAddLine() {
        var promise = jQuery.Deferred();

        var isFormCompleted = Utils.getParameterByName(
          window.location.href,
          "custcol_form_completed"
        );
        var item = pdp.getItemInfo();
        var isConfigurable =
          item && item.item && item.item.custitem_option1description
            ? true
            : false;
        var missingSelection = false;
        $(".configurable-option-select").each(function () {
          var selectedText = $(this).find("option:selected").text().trim();
          if (selectedText === "- Select -") {
            missingSelection = true;
            return false;
          }
        });
        if ((isFormCompleted !== "T" && isConfigurable) || missingSelection) {
          promise.reject();
          setTimeout(function () {
            $(".error-message").text("Please select the configuration options");
          }, 100);
        } else {
          promise.resolve();
        }

        return promise;
      });

      layout.addToViewContextDefinition(
        "ProductViews.Price.View",
        "priceFormatted",
        "string",
        function (context) {
          var newPrice = context.model.custcol_custom_price
            ? parseFloat(context.model.custcol_custom_price)
            : null;
          var formattedPrice = newPrice
            ? Utils.formatCurrency(newPrice)
            : context.priceFormatted;
          return formattedPrice;
        }
      );

      // layout.addToViewContextDefinition('Transaction.Line.Views.Price.View', 'rateFormatted', 'string', function (context) {
      // 	var options = context.model.options;
      // 	// get cartOptionId called custcol_custom_price from the line options
      // 	var rate = _.find(options, function (option) {
      // 		return option.cartOptionId === 'custcol_custom_price';
      // 	});
      // 	if (rate && rate.value) {
      // 		return Utils.formatCurrency(rate.value.label);
      // 	} else {
      // 		return context.rateFormatted;
      // 	}

      // });

      // layout.addToViewContextDefinition('Header.MiniCartItemCell.View', 'rateFormatted', 'string', function (context) {
      // 	var options = context.line.options;
      // 	// get cartOptionId called custcol_custom_price from the line options
      // 	var rate = _.find(options, function (option) {
      // 		return option.cartOptionId === 'custcol_custom_price';
      // 	});
      // 	if (rate && rate.value) {
      // 		return Utils.formatCurrency(rate.value.label);
      // 	} else {
      // 		return context.rateFormatted;
      // 	}

      // });

      // layout.addToViewContextDefinition('Cart.Summary.View', 'summary', 'object', function (context) {
      // 	var lines = context.model.lines;
      // 	var newLines = [];
      // 	var newSubtotal = 0;

      // 	lines.forEach(function (line) {
      // 		var options = line.options;
      // 		var rate = _.find(options, function (option) {
      // 			return option.cartOptionId === 'custcol_custom_price';
      // 		});
      // 		if (rate && rate.value) {
      // 			line.rate = parseFloat(rate.value.label);
      // 		}
      // 		newLines.push(line);
      // 		newSubtotal += line.rate * line.quantity;
      // 	});
      // 	 context.summary.subtotal_formatted = Utils.formatCurrency(newSubtotal);
      // 	return context.summary;

      // });

      // layout.addToViewContextDefinition('Cart.Item.Summary.View', 'line', 'object', function (context) {
      // 	var options = context.line.options;
      // 	// get cartOptionId called custcol_custom_price from the line options
      // 	var rate = _.find(options, function (option) {
      // 		return option.cartOptionId === 'custcol_custom_price';
      // 	});
      // 	if (rate && rate.value) {
      // 		var newrate = Utils.formatCurrency(rate.value.label * context.line.quantity);
      // 		context.line.total_formatted = newrate;
      // 	}
      // 	return context.line;

      // });

      // layout.addToViewContextDefinition('ProductViews.Option.View', 'excludeOption', 'boolean', function (context) {
      // 	return true
      // });

      layout.addToViewContextDefinition(
        "Cart.AddToCart.Button.View",
        "isCurrentItemPurchasable",
        "boolean",
        function (context) {
          var profile = ProfileModel.getInstance();
          var item = pdp.getItemInfo();
          var isConfigurable =
            item && item.item && item.item.custitem_option1description
              ? true
              : false;
          if (isConfigurable) {
            if (
              profile.get("isLoggedIn") === "T" &&
              context.isCurrentItemPurchasable
            ) {
              return true;
            } else {
              return false;
            }
          } else {
            return context.isCurrentItemPurchasable;
          }
        }
      );

      if (layout) {
        layout.addChildView("Quantity", function () {
          return new COnfigurablePDPView({ container: container });
        });
      }
    },
  };
});
